export default __webpack_public_path__ + "static/gamerize-2-c-baa3d1e592254e6561ea63066ab52eed.webp";